export const MAX_FOLDERS = 15
export const MOVE_TO_FOLDER_LOCATION = {
  MULTI_SELECT: 'multiSelect',
  ASSESSMENT_CARD: 'assessmentCard'
} as const
